export default "__VITE_ASSET__CEXpXENV__"